import { FunctionComponent } from 'react'
import { StandardTeaserAPIProps } from './types'
import StandardTeaserComponents from '@components/Teaser/Standard'
import { getVideoData } from '../utils'
import { TeaserVideo } from '../types'

interface ExtraDataProps extends Pick<StandardTeaserAPIProps, 'logo'> {
  video?: TeaserVideo
  isOnImage: boolean
}

const { Logo, VideoInfo } = StandardTeaserComponents

const ExtraData: FunctionComponent<ExtraDataProps> = ({
  logo,
  video,
  isOnImage,
}) => {
  const videoData = getVideoData(video)
  const isLive = videoData?.duration === -1

  if (!logo?.src && !videoData) {
    return null
  }

  return (
    <>
      {logo?.src ? (
        <Logo
          src={logo.src}
          alt={logo.alt}
          width={logo.width}
          height={logo.height}
          crops={logo.crops ?? {}}
          isOnImage={isOnImage}
        />
      ) : null}
      {videoData ? (
        <VideoInfo>{isLive ? 'LIVE' : videoData.formattedDuration}</VideoInfo>
      ) : null}
    </>
  )
}

export default ExtraData
